import { useState, useEffect, useCallback } from "react";
import { useApi } from "../../api/useApi";
import { FormControl } from "../../components/Form/FormControls";
import { useSearch } from "../../Hooks/useSearch";
import { standardsList } from "../../api/ruleQueries";
import SearchSelect from "../../components/Forms/Search/SearchSelect";

const SearchPolicies = ({ ruleType, setMapId }) => {
  const [stateSources, setStateSources] = useState();
  const [{ errors, loading, data }, doFetch] = useApi();

  useEffect(() => {
    if (data) {
      const userOptions = data?.availableBusinessRuleStandards?.edges?.map(
        (ug) => {
          const policy = ug?.node;
          return {
            label: policy?.name,
            value: policy?.id,
          };
        }
      );

      setStateSources(userOptions);
    }
  }, [data]);

  const onSearch = useCallback(
    (text) => {
      if (text) {
        doFetch({
          query: standardsList,
          variables: {
            where: {
              or: [{ name: { contains: text } }],
            },
            standardType: ruleType === 1 ? "RULE" : "FILTER",
            order: [{ name: "ASC" }],
            tagFilter: {
              tagIds: [],
              exactMatch: false,
            },
          },
        });
      }
    },
    [doFetch, ruleType]
  );

  const { inputText, handleInputChange, tooShortWarning } = useSearch({
    onSearch,
  });

  return (
    <div style={{ marginTop: "1rem" }}>
      <FormControl style={{ maxWidth: "300px" }}>
        <SearchSelect
          menuPlacement="auto"
          menuPortalTarget={document.body}
          label="Search"
          placeholder="Search"
          options={stateSources}
          onChange={(e) => setMapId(e?.value)}
          inputValue={inputText}
          onInputChange={handleInputChange}
          loading={loading}
          error={errors}
          warning={tooShortWarning}
        />
      </FormControl>
    </div>
  );
};

export default SearchPolicies;
